import EmailUtils from 'store/utils/EmailUtils'
import SubscribeService from 'services/AirBaltic/Pax/Subscribe'
import divolteSubscribe from 'services/AirBaltic/Divolte/Subscribe'
import fbMarketing from 'services/AirBaltic/FBMarketing'
import ErrorHandler from 'utils/ErrorHandler'
import * as Sentry from '@sentry/vue'

const ERRORS = {
  ALREADY_SUBSCRIBED: EmailUtils.alreadySubscribedResponse()
}

const SubscribeMixins = {
  methods: {
    onChange() {
      this.formErrors = EmailUtils.validateEmail(this.$v.email)
    },

    onInput() {
      if (this.$v) {
        this.$v.email.$touch()
      }

      if (this.formErrors.length) {
        this.formErrors = EmailUtils.validateEmail(this.$v.email)
      }
    },

    subscribeWithApi () {
      this.formErrors = EmailUtils.validateEmail(this.$v.email)
      if (this.formErrors.length) {
        return false
      }

      const postObject = {
        email: this.email,
        subscribeSource: this.subscribeSource,
        language: this.selectedLang.toUpperCase()
      }

      if (this.selectedCountry.toUpperCase() !== 'ZZ') {
        postObject.country = this.selectedCountry.toUpperCase()
      }

      new SubscribeService()
        .subscribeWithApi(postObject)
        .then((response) => {
          if (response.message === 'SUCCESS') {
            divolteSubscribe.subscribe(postObject)
            fbMarketing.doDataPush(this.email)
            this.successAction()
          }
        })
        .catch((e) => {
          Sentry.captureException(e)
          this.formErrors = [ErrorHandler.getErrorTranslationKey(ERRORS, e)]
          divolteSubscribe.subscribe(postObject)
        })
    },

    successAction() {
      window.location = this.subscribedRedirectURL
    }
  }
}
export default SubscribeMixins
